import type { Segment, VoterDataGeography } from '@signalvote/shared';

export type RuleKey = { fieldId: string; values: string[] } | { fieldId: string; voted: boolean };

export interface SegmentKey {
  state: string;
  areas: { geography: VoterDataGeography; codes: string[] }[];
  rules: RuleKey[];
}

export function segmentKey(segment: Segment): SegmentKey {
  const rules = (segment.rules ?? [])
    .map((r): RuleKey => (r.kind === 'Voted' ? { fieldId: r.fieldId, voted: r.voted } : { fieldId: r.fieldId, values: [...r.values].sort() }))
    .sort((a, b) => (a.fieldId < b.fieldId ? -1 : a.fieldId > b.fieldId ? 1 : 0));
  const state = segment.state ?? '';
  const areas = segment.areas
    .map((a) => ({ geography: a.geography, codes: [...a.codes].sort() }))
    .sort((a, b) => (a.geography < b.geography ? -1 : a.geography > b.geography ? 1 : 0));
  return { state, areas, rules };
}

export const sameArea = (a: SegmentKey, b: SegmentKey) => a.state === b.state && JSON.stringify(a.areas) === JSON.stringify(b.areas);

export const isVoteRule = (rule: RuleKey): rule is { fieldId: string; voted: boolean } => 'voted' in rule;

export const sameRule = (a: RuleKey, b: RuleKey) =>
  isVoteRule(a) ? isVoteRule(b) && a.voted === b.voted : !isVoteRule(b) && a.values.length === b.values.length && a.values.every((v, i) => v === b.values[i]);

/** A search of one state's places: of one kind, or with `kind` null of every kind at once; `county` narrows precincts. */
export interface VoterPlaceSearch {
  state: string;
  kind: VoterDataGeography | null;
  q: string;
  county: string | null;
}
